import styled from 'styled-components'

export const BookPreviewContainer = styled.div`
  .note {
    margin: 20px 0;
    border: 1px solid;
    padding: 8px;
    font-weight: bold;
  }

  .actions {
    padding: 8px 20px;
    display: flex;
    justify-content: flex-start;
    .btn {
      margin-right: 1rem;
    }
  }
`
